export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=703e9963c34c0cd419f248301eb8181eae1ea3cc39&name=pushAdClickData!'